import { CARD_STATUS } from '../../../modules/fluency/deck-report';
import CellFluency from '../../cell-fluency';
import { CELL_VARIANT } from '../../cell-fluency/cell-fluency';

function SkeletonCell({
  allCellsLocked,
}: {
  allCellsLocked?: boolean;
}): JSX.Element {
  return (
    <CellFluency
      status={CARD_STATUS.SKELETON}
      variant={CELL_VARIANT.CELL_NORMAL_SIZE}
      allCellsLocked={allCellsLocked}
    />
  );
}

export { SkeletonCell };
